import React, { PureComponent } from 'react';
import axios from 'axios';
import classNames from 'classnames';

// Images
import Arrow from 'images/icons/arrow.svg';
import Checked from 'images/icons/checked.svg';
import Exclamation from 'images/icons/exclamation.svg';

import './style.css';


class HomeSubscriptions extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      subscribe: true,
      email: '',
      validEmail: false,
      success: false
    };
  }
  onClickSubscriptions = () => {
    this.setState({ subscribe: false })
  }

  onClickSubmit = (e) => {
    e.preventDefault();
    const { email, validEmail } = this.state;

    if (validEmail) {
      axios.get('https://script.google.com/macros/s/AKfycbxLK6GhnNI3bO0XaPTwtBA5KzNXhJ9P54t0P-EvuWYuouvzM4M/exec', {
        params: { email }
      })
        .then((response) => {
          this.setState({ subscribe: true, validEmail: true });
        })
        .catch((err) => {
          console.error(err);
        })
    }
    this.setState({ success: true });
}

  render() {
    const { subscribe, email, validEmail, success } = this.state;
    return (
      <div className="home-subscriptions">
        <h3>SUBSCRIBE NOW!</h3>
        <h4>Enter your email to receive updates</h4>
        { subscribe &&
          <button className="subscriptions-btn"
            onClick={this.onClickSubscriptions}>Subscribe</button>
        }
        { !subscribe &&

          <form className="form" onSubmit={this.onClickSubmit}>
            <input
              name="email"
              value={email}
              type="email"
              className={classNames({
                'subscriptions-input-error': !validEmail && email,

            })}
            placeholder="Your email"
              onChange={(e) => {
                const value = e.target.value;
                this.setState({
                  email: value,
                  validEmail: /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(value)
                })
              }}
            />
            <div className={classNames({
              'subscriptions-error': !validEmail && email,

            })}>
            <button className={classNames({
              'subscription-btn-input': !subscribe && !email,
              'subscriptions-btn-error': !validEmail && email,
              'subscription-btn-correct': validEmail && email,
              'subscriptions-btn': !subscribe
            })}
              type="submit" id="submit-form">
                  {!subscribe && email && validEmail &&
                    <img alt="correct-email" className="subscriptions-field" src={Checked} />}
                  {!subscribe && email && !validEmail &&
                    <img alt="wrong-email" className="subscriptions-field" src={Exclamation} />}
                  {!subscribe && !email &&
                    <img alt="tool" className="subscriptions-field" src={Arrow} />}
            </button>
          </div>
                {!subscribe && email && !validEmail &&
                  <p className="error-msg">Email format invalid</p>}
                {success &&
                  <p className="succes-msg">Subscribed susccesfully</p>}
          </form>
        }
      </div>
    );
  };
}


export default HomeSubscriptions;



// WEBPACK FOOTER //
// ./src/pages/home/home-subscriptions/index.js